/* ─────────────────────────────────────────────────────────────
   Symbol definitions for autocomplete + Yahoo Finance mapping
   ───────────────────────────────────────────────────────────── */

export const SYMBOLS = {
  BIST: [
    { symbol: "THYAO",    name: "Türk Hava Yolları"                  },
    { symbol: "BIMAS",    name: "BİM Birleşik Mağazalar"             },
    { symbol: "GARAN",    name: "Garanti BBVA"                       },
    { symbol: "AKBNK",    name: "Akbank"                             },
    { symbol: "ISCTR",    name: "İş Bankası C"                       },
    { symbol: "YKBNK",    name: "Yapı Kredi"                         },
    { symbol: "HALKB",    name: "Halk Bankası"                       },
    { symbol: "VAKBN",    name: "Vakıfbank"                          },
    { symbol: "TSKB",     name: "Türkiye Sınai Kalkınma Bankası"     },
    { symbol: "SKBNK",    name: "Şekerbank"                          },
    { symbol: "ALBRK",    name: "Albaraka Türk"                      },
    { symbol: "KLNMA",    name: "Kalkınma Yatırım Bankası"           },
    { symbol: "AGESA",    name: "Agesa Hayat ve Emeklilik"           },
    { symbol: "KCHOL",    name: "Koç Holding"                        },
    { symbol: "SAHOL",    name: "Sabancı Holding"                    },
    { symbol: "DOHOL",    name: "Doğan Holding"                      },
    { symbol: "AGHOL",    name: "AG Anadolu Grubu Holding"           },
    { symbol: "GSDHO",    name: "GSD Holding"                        },
    { symbol: "ALARK",    name: "Alarko Holding"                     },
    { symbol: "PGSUS",    name: "Pegasus"                            },
    { symbol: "TAVHL",    name: "TAV Havalimanları"                  },
    { symbol: "UCAK",     name: "Çelebi Hava Servisi"                },
    { symbol: "FROTO",    name: "Ford Otosan"                        },
    { symbol: "TOASO",    name: "Tofaş Oto Fabrikası"                },
    { symbol: "TTRAK",    name: "Türk Traktör"                       },
    { symbol: "DOAS",     name: "Doğuş Otomotiv"                     },
    { symbol: "OTKAR",    name: "Otokar"                             },
    { symbol: "TCELL",    name: "Turkcell"                           },
    { symbol: "TTKOM",    name: "Türk Telekom"                       },
    { symbol: "LOGO",     name: "Logo Yazılım"                       },
    { symbol: "NETAS",    name: "Netaş Telekomünikasyon"             },
    { symbol: "KONTR",    name: "Kontrolmatik"                       },
    { symbol: "MGROS",    name: "Migros"                             },
    { symbol: "SOKM",     name: "Şok Marketler"                      },
    { symbol: "BRYAT",    name: "Boyner Büyük Mağazacılık"           },
    { symbol: "MAVI",     name: "Mavi Giyim"                         },
    { symbol: "AEFES",    name: "Anadolu Efes"                       },
    { symbol: "CCOLA",    name: "Coca-Cola İçecek"                   },
    { symbol: "ULKER",    name: "Ülker Bisküvi"                      },
    { symbol: "TATGD",    name: "Tat Gıda"                           },
    { symbol: "ULUUN",    name: "Ulusoy Un"                          },
    { symbol: "BANVT",    name: "Banvit"                             },
    { symbol: "TUPRS",    name: "Tüpraş"                             },
    { symbol: "PETKM",    name: "Petkim"                             },
    { symbol: "AHGAZ",    name: "Akenerji Doğalgaz"                  },
    { symbol: "AKSA",     name: "Aksa Akrilik"                       },
    { symbol: "ENJSA",    name: "Enerjisa Enerji"                    },
    { symbol: "ZOREN",    name: "Zorlu Enerji"                       },
    { symbol: "ODAS",     name: "Odaş Elektrik"                      },
    { symbol: "EUPWR",    name: "Europower Enerji"                   },
    { symbol: "BIOEN",    name: "Bioenerji Elektrik"                 },
    { symbol: "SNKRN",    name: "Sanko Enerji"                       },
    { symbol: "ASTOR",    name: "Astor Enerji"                       },
    { symbol: "EREGL",    name: "Ereğli Demir Çelik"                 },
    { symbol: "KRDMD",    name: "Kardemir D"                         },
    { symbol: "KRDMA",    name: "Kardemir A"                         },
    { symbol: "ISDMR",    name: "İskenderun Demir Çelik"             },
    { symbol: "IZMDC",    name: "İzmir Demir Çelik"                  },
    { symbol: "KOZAL",    name: "Koza Altın"                         },
    { symbol: "ALKIM",    name: "Alkim Kimya"                        },
    { symbol: "SISE",     name: "Şişecam"                            },
    { symbol: "CIMSA",    name: "Çimsa Çimento"                      },
    { symbol: "OYAKC",    name: "Oyak Çimento"                       },
    { symbol: "BTCIM",    name: "BATIÇİM Batı Çimento"               },
    { symbol: "BUCIM",    name: "Bursa Çimento"                      },
    { symbol: "EKGYO",    name: "Emlak Konut GYO"                    },
    { symbol: "ENKAI",    name: "Enka İnşaat"                        },
    { symbol: "TRGYO",    name: "Torunlar GYO"                       },
    { symbol: "ISGYO",    name: "İş GYO"                             },
    { symbol: "PEKGY",    name: "Peker GYO"                          },
    { symbol: "ASELS",    name: "Aselsan"                            },
    { symbol: "ARCLK",    name: "Arçelik"                            },
    { symbol: "VESTL",    name: "Vestel"                             },
    { symbol: "KORDS",    name: "Kordsa Teknik Tekstil"              },
    { symbol: "BRISA",    name: "Brisa Bridgestone Sabancı"          },
    { symbol: "SASA",     name: "SASA Polyester"                     },
    { symbol: "GUBRF",    name: "Gübre Fabrikaları"                  },
    { symbol: "HEKTS",    name: "Hektaş"                             },
    { symbol: "EGEEN",    name: "Ege Endüstri"                       },
    { symbol: "SELEC",    name: "Selçuk Ecza Deposu"                 },
    { symbol: "MPARK",    name: "MLP Sağlık"                         },
    { symbol: "DEVA",     name: "Deva Holding"                       },
    { symbol: "TKFEN",    name: "Tekfen Holding"                     },
    { symbol: "POLHO",    name: "Polisan Holding"                    },
    { symbol: "GESAN",    name: "Gesan Elektrik"                     },
    { symbol: "YATAS",    name: "Yataş Yatak ve Yorgan"              },
    { symbol: "KARTN",    name: "Kartonsan"                          },
    { symbol: "FENER",    name: "Fenerbahçe Futbol"                  },
    { symbol: "GSRAY",    name: "Galatasaray Sportif"                },
    { symbol: "BJKAS",    name: "Beşiktaş Futbol"                    },
    { symbol: "TSPOR",    name: "Trabzonspor"                        },
  ],

  NASDAQ: [
    { symbol: "AAPL",  name: "Apple"                },
    { symbol: "MSFT",  name: "Microsoft"            },
    { symbol: "GOOGL", name: "Alphabet (Google)"    },
    { symbol: "AMZN",  name: "Amazon"               },
    { symbol: "NVDA",  name: "NVIDIA"               },
    { symbol: "META",  name: "Meta Platforms"       },
    { symbol: "TSLA",  name: "Tesla"                },
    { symbol: "AMD",   name: "AMD"                  },
    { symbol: "INTC",  name: "Intel"                },
    { symbol: "QCOM",  name: "Qualcomm"             },
    { symbol: "AVGO",  name: "Broadcom"             },
    { symbol: "MU",    name: "Micron Technology"    },
    { symbol: "AMAT",  name: "Applied Materials"    },
    { symbol: "LRCX",  name: "Lam Research"         },
    { symbol: "KLAC",  name: "KLA Corporation"      },
    { symbol: "MRVL",  name: "Marvell Technology"   },
    { symbol: "ASML",  name: "ASML Holding"         },
    { symbol: "SMCI",  name: "Super Micro Computer" },
    { symbol: "TXN",   name: "Texas Instruments"    },
    { symbol: "ADI",   name: "Analog Devices"       },
    { symbol: "NXPI",  name: "NXP Semiconductors"   },
    { symbol: "CRM",   name: "Salesforce"           },
    { symbol: "ADBE",  name: "Adobe"                },
    { symbol: "ORCL",  name: "Oracle"               },
    { symbol: "INTU",  name: "Intuit"               },
    { symbol: "NOW",   name: "ServiceNow"           },
    { symbol: "WDAY",  name: "Workday"              },
    { symbol: "TEAM",  name: "Atlassian"            },
    { symbol: "HUBS",  name: "HubSpot"              },
    { symbol: "DDOG",  name: "Datadog"              },
    { symbol: "SNOW",  name: "Snowflake"            },
    { symbol: "CDNS",  name: "Cadence Design"       },
    { symbol: "SNPS",  name: "Synopsys"             },
    { symbol: "PANW",  name: "Palo Alto Networks"   },
    { symbol: "CRWD",  name: "CrowdStrike"          },
    { symbol: "ZS",    name: "Zscaler"              },
    { symbol: "OKTA",  name: "Okta"                 },
    { symbol: "FTNT",  name: "Fortinet"             },
    { symbol: "CSCO",  name: "Cisco"                },
    { symbol: "NET",   name: "Cloudflare"           },
    { symbol: "SHOP",  name: "Shopify"              },
    { symbol: "MELI",  name: "MercadoLibre"         },
    { symbol: "PDD",   name: "PDD Holdings"         },
    { symbol: "BKNG",  name: "Booking Holdings"     },
    { symbol: "ABNB",  name: "Airbnb"               },
    { symbol: "UBER",  name: "Uber"                 },
    { symbol: "DASH",  name: "DoorDash"             },
    { symbol: "LULU",  name: "Lululemon"            },
    { symbol: "NFLX",  name: "Netflix"              },
    { symbol: "SPOT",  name: "Spotify"              },
    { symbol: "RBLX",  name: "Roblox"              },
    { symbol: "ROKU",  name: "Roku"                 },
    { symbol: "EA",    name: "Electronic Arts"      },
    { symbol: "PYPL",  name: "PayPal"               },
    { symbol: "SQ",    name: "Block (Square)"       },
    { symbol: "COIN",  name: "Coinbase"             },
    { symbol: "HOOD",  name: "Robinhood"            },
    { symbol: "SOFI",  name: "SoFi Technologies"    },
    { symbol: "PLTR",  name: "Palantir"             },
    { symbol: "TTD",   name: "The Trade Desk"       },
    { symbol: "PATH",  name: "UiPath"               },
    { symbol: "RIVN",  name: "Rivian"               },
    { symbol: "LCID",  name: "Lucid Group"          },
    { symbol: "ISRG",  name: "Intuitive Surgical"   },
    { symbol: "GILD",  name: "Gilead Sciences"      },
    { symbol: "REGN",  name: "Regeneron"            },
    { symbol: "MRNA",  name: "Moderna"              },
    { symbol: "BIIB",  name: "Biogen"               },
    { symbol: "ZM",    name: "Zoom"                 },
    { symbol: "TWLO",  name: "Twilio"               },
    { symbol: "SNAP",  name: "Snap"                 },
  ],

  KRIPTO: [
    { symbol: "BTC",   name: "Bitcoin"       },
    { symbol: "ETH",   name: "Ethereum"      },
    { symbol: "BNB",   name: "BNB"           },
    { symbol: "SOL",   name: "Solana"        },
    { symbol: "XRP",   name: "XRP"           },
    { symbol: "ADA",   name: "Cardano"       },
    { symbol: "AVAX",  name: "Avalanche"     },
    { symbol: "DOT",   name: "Polkadot"      },
    { symbol: "MATIC", name: "Polygon"       },
    { symbol: "LINK",  name: "Chainlink"     },
    { symbol: "LTC",   name: "Litecoin"      },
    { symbol: "BCH",   name: "Bitcoin Cash"  },
    { symbol: "ATOM",  name: "Cosmos"        },
    { symbol: "NEAR",  name: "NEAR Protocol" },
    { symbol: "DOGE",  name: "Dogecoin"      },
    { symbol: "UNI",   name: "Uniswap"       },
    { symbol: "SHIB",  name: "Shiba Inu"     },
    { symbol: "FTM",   name: "Fantom"        },
    { symbol: "ARB",   name: "Arbitrum"      },
    { symbol: "OP",    name: "Optimism"      },
  ],

  KMADEN: [
    { symbol: "ALTIN",    name: "Altın",          yahoo: "GC=F"  },
    { symbol: "GUMUS",    name: "Gümüş",          yahoo: "SI=F"  },
    { symbol: "PETROL",   name: "Ham Petrol (WTI)",yahoo: "CL=F"  },
    { symbol: "BRENT",    name: "Brent Petrol",    yahoo: "BZ=F"  },
    { symbol: "PLATIN",   name: "Platin",          yahoo: "PL=F"  },
    { symbol: "PALADYUM", name: "Paladyum",        yahoo: "PA=F"  },
    { symbol: "BAKIR",    name: "Bakır",           yahoo: "HG=F"  },
    { symbol: "DOGALGAZ", name: "Doğal Gaz",       yahoo: "NG=F"  },
    { symbol: "BUGDAY",   name: "Buğday",          yahoo: "ZW=F"  },
    { symbol: "MISIR",    name: "Mısır",           yahoo: "ZC=F"  },
  ],
};

/** Returns the Yahoo Finance ticker for a given symbol + category */
export const getYahooSymbol = (symbol, category) => {
  if (category === "BIST")   return `${symbol}.IS`;
  if (category === "NASDAQ") return symbol;
  if (category === "KRIPTO") return `${symbol}-USD`;
  if (category === "KMADEN") {
    const item = SYMBOLS.KMADEN.find((s) => s.symbol === symbol);
    return item?.yahoo || symbol;
  }
  return symbol;
};

/** Currency symbol for a category */
export const getCurrency = (category) =>
  category === "BIST" ? "₺" : "$";

const CAT_ORDER = ["BIST", "NASDAQ", "KRIPTO", "KMADEN"];

/**
 * Given a symbol, return which category it belongs to.
 * Returns null if unknown.
 */
export const detectCategory = (symbol) => {
  const sym = (symbol || "").trim().toUpperCase();
  for (const cat of CAT_ORDER) {
    if ((SYMBOLS[cat] || []).some((s) => s.symbol === sym)) return cat;
  }
  return null;
};

/**
 * Search across ALL categories and return up to 8 results
 * each enriched with a `category` field.
 */
export const filterSymbolsAll = (query) => {
  if (!query || query.trim().length === 0) return [];
  const q = query.trim().toUpperCase();
  const results = [];
  for (const cat of CAT_ORDER) {
    const hits = (SYMBOLS[cat] || [])
      .filter((s) => s.symbol.startsWith(q) || s.name.toUpperCase().includes(q))
      .map((s) => ({ ...s, category: cat }));
    results.push(...hits);
  }
  return results.slice(0, 8);
};

/** Filter symbols by query for a single category (kept for compatibility) */
export const filterSymbols = (category, query) => {
  if (!query) return [];
  const q = query.toUpperCase();
  return (SYMBOLS[category] || [])
    .filter((s) => s.symbol.startsWith(q) || s.name.toUpperCase().includes(q))
    .slice(0, 6);
};
